import { NavItemModel } from '../../common';

export type UserHomePageType = 'anonymousWeb' | 'anonymousApp' | 'authenticated' | 'bmi';
export const userHomeContentIds: Record<UserHomePageType, string> = {
  anonymousWeb: '380',
  anonymousApp: '3332',
  authenticated: '1572',
  bmi: '2143',
};

export const USER_LOGIN_ROUTE_NAME: string = 'auth';
export const USER_LOGIN_ROUTE_PATH: string = 'auth';
export const userLoginNavItem: NavItemModel = {
  name: USER_LOGIN_ROUTE_NAME,
  url: `/${USER_LOGIN_ROUTE_PATH}`,
  type: 'content',
  label: 'Anmelden',
  icon: {
    name: 'user',
    family: 'light',
  },
};

export const USER_LOGOUT_ROUTE_NAME: string = 'logout';
export const USER_LOGOUT_ROUTE_PATH: string = 'logout';
export const userLogoutNavItem: NavItemModel = {
  name: USER_LOGOUT_ROUTE_NAME,
  url: `/${USER_LOGOUT_ROUTE_PATH}`,
  label: 'Abmelden',
  icon: {
    name: 'right-from-bracket',
    family: 'light',
  },
};

export const USER_HOME_ROUTE_NAME: string = 'home';
export const USER_HOME_ROUTE_PATH: string = 'home';
export const userHomeNavItem: NavItemModel = {
  name: USER_HOME_ROUTE_NAME,
  url: `/${USER_HOME_ROUTE_PATH}`,
  type: 'content',
  label: 'Startseite',
  icon: {
    name: 'house',
    family: 'light',
  },
};

export const USER_ACCOUNT_ROUTE_NAME: string = 'account';
export const USER_ACCOUNT_ROUTE_PATH: string = 'account';
export const userAccountNavItem: NavItemModel = {
  name: USER_ACCOUNT_ROUTE_NAME,
  url: `/${USER_ACCOUNT_ROUTE_PATH}`,
  label: 'Mein Konto',
  icon: {
    name: 'user',
    family: 'light',
  },
};

export const USER_CUSTOMER_SWITCH_ROUTE_NAME: string = 'switch-customer';
export const USER_CUSTOMER_SWITCH_ROUTE_PATH: string = 'switch-customer';
export const userCustomerSwitchNavItem: NavItemModel = {
  name: USER_CUSTOMER_SWITCH_ROUTE_NAME,
  url: `/${USER_CUSTOMER_SWITCH_ROUTE_PATH}`,
  label: 'Kundennummer auswählen',
  icon: {
    name: 'arrows-repeat',
    family: 'light',
  },
};

export const USER_CUSTOMER_PORTAL_ROUTE_NAME: string = 'customer-portal';
export const USER_CUSTOMER_PORTAL_ROUTE_URL: string = 'https://portal.lekkerland.de';
export const userCustomerPortalNavItem: NavItemModel = {
  name: USER_CUSTOMER_PORTAL_ROUTE_NAME,
  url: USER_CUSTOMER_PORTAL_ROUTE_URL,
  target: '_blank',
  label: 'Kundenportal',
  icon: {
    name: 'laptop',
    family: 'light',
  },
};

export const accountNavigation: NavItemModel[] = [
  userAccountNavItem,
  userCustomerPortalNavItem,
  userCustomerSwitchNavItem,
];

export const authNavigation: NavItemModel[] = [
  userLogoutNavItem,
];
